import { Zap, LogOut } from "lucide-react";
import { Button } from "./ui/button";
import { CATEGORIES } from "../lib/api";

export default function Header({ csvInfoByCategory, onLogout }) {
  return (
    <header className="sticky top-0 z-40 bg-white/75 backdrop-blur-xl border-b border-[#1A2340]/15">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center gap-5">
        <div className="flex items-center gap-3" data-testid="brand-logo">
          <img
            src="/attomfit-logo.png"
            alt="AttomFit"
            className="h-12 w-auto object-contain"
          />
        </div>
        <div className="h-7 w-px bg-[#1A2340]/15" />
        <div className="flex items-center gap-2">
          <Zap size={14} className="text-[#F5C800] fill-[#F5C800]" strokeWidth={2.5} />
          <div>
            <div className="eyebrow text-[#64748B] leading-none mb-0.5">Pricing Engine</div>
            <div className="text-[13px] font-semibold text-[#1A2340] leading-none">Automated Margin Calculator</div>
          </div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          {CATEGORIES.map((c) => {
            const info = csvInfoByCategory?.[c.value];
            return info?.loaded ? (
              <div
                key={c.value}
                className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-sm"
                data-testid={`csv-status-loaded-${c.value}`}
              >
                <span className="w-2 h-2 bg-emerald-500 rounded-full pulse-bar" />
                <span className="text-[11px] font-semibold text-emerald-800">{c.label}</span>
                <span className="text-[11px] text-emerald-700">· {info.row_count?.toLocaleString()} rows</span>
              </div>
            ) : (
              <div
                key={c.value}
                className="flex items-center gap-2 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-sm"
                data-testid={`csv-status-empty-${c.value}`}
              >
                <span className="w-2 h-2 bg-amber-500 rounded-full" />
                <span className="text-[11px] font-semibold text-amber-800">{c.label} not loaded</span>
              </div>
            );
          })}
          {onLogout && (
            <Button
              variant="outline"
              size="sm"
              onClick={onLogout}
              className="rounded-sm h-8 text-xs gap-2 border-[#1A2340]/20 hover:bg-[#1A2340] hover:text-white"
              data-testid="logout-button"
            >
              <LogOut size={13} /> Sign Out
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
